import type { ReactNode } from "react";

import { cn } from "@/lib/helpers/cn";

type IndexedOptionContentProps = {
  index: string;
  isSelected: boolean;
  label: ReactNode;
};

export function IndexedOptionContent({ index, isSelected, label }: IndexedOptionContentProps) {
  return (
    <>
      {/* Index badge */}
      <span
        className={cn(
          "tw:inline tw:size-8 tw:shrink-0 tw:text-center tw:leading-8!",
          "tw:rounded-[5px] tw:border-2 tw:border-stroke-tertiary!",
          "tw:transition-all tw:duration-200",
          "tw:flex tw:items-center tw:justify-center",

          isSelected
            ? "tw:border-stroke-teal-primary! tw:bg-fill-teal-primary tw:text-text-white"
            : "tw:border-stroke-secondary tw:bg-fill-white tw:text-text-secondary",
        )}
      >
        {index}
      </span>

      <p
        className={cn(
          "tw:flex tw:flex-1 tw:flex-col tw:gap-1 tw:text-md",
          isSelected ? "tw:text-text-teal-primary" : "tw:text-text-primary",
        )}
      >
        <span className={cn(isSelected && "tw:font-semibold")}>{label}</span>
      </p>
    </>
  );
}
